import { Button, ButtonGroup } from '@mui/material';
import { CodJourney } from 'src/constants/assemblyJourneys';

export const ScreenConfigButtonGroup = ({
  selectedState,
  setSelectedState,
  orderStates,
}: {
  selectedState: CodJourney;
  setSelectedState: React.Dispatch<React.SetStateAction<CodJourney>>;
  orderStates: CodJourney[];
}) => {
  return (
    <ButtonGroup size="small" sx={{ marginBottom: 2 }}>
      {orderStates.map((state) => (
        <Button
          key={state}
          sx={{ width: '170px', fontSize: '12px' }}
          variant={selectedState === state ? 'contained' : 'outlined'}
          onClick={(event) => {
            setSelectedState(state);
            event.stopPropagation();
          }}>
          {state}
        </Button>
      ))}
    </ButtonGroup>
  );
};
